import { cn } from '@/lib/utils';
import type { NoyauCode } from '@rosetta/shared';
import { styleNoyau } from './noyaux-affichage';

interface PastilleNoyauProps {
  noyau: NoyauCode;
  className?: string;
}

/** The round 12 px dot in the colour of a noyau. Decorative: the code always sits beside it. */
export function PastilleNoyau({ noyau, className }: PastilleNoyauProps) {
  return (
    <span
      aria-hidden="true"
      className={cn('size-3 shrink-0 rounded-full', styleNoyau(noyau).pastille, className)}
    />
  );
}
